import { UseData } from './useData'

type Props = Pick<UseData, 'drawerOpen' | 'setDrawerOpen'>

export function useHandlers(props: Props) {
  const { drawerOpen, setDrawerOpen } = props

  function handleClick() {
    setDrawerOpen(!drawerOpen)
  }

  return { handleClick }
}
